import React, { createContext, useContext, useState, useCallback } from 'react';

const ToastContext = createContext(() => {});

export const useToast = () => useContext(ToastContext);

export const ToastProvider = ({ children }) => {
    const [toasts, setToasts] = useState([]);

    // Pass the triggering element (or event) to anchor the toast above it
    const showToast = useCallback((message, anchor) => {
        const id = Date.now() + Math.random();

        let position = null;
        const el = anchor?.currentTarget || anchor?.target || anchor;
        if (el && typeof el.getBoundingClientRect === 'function') {
            const rect = el.getBoundingClientRect();
            position = {
                left: rect.left + rect.width / 2,
                top: rect.top - 65
            };
        }

        setToasts(prev => [...prev, { id, message, position }]);
        setTimeout(() => {
            setToasts(prev => prev.filter(t => t.id !== id));
        }, 1500);
    }, []);

    return (
        <ToastContext.Provider value={showToast}>
            {children}

            {toasts.filter(t => t.position).map(t => (
                <div
                    key={t.id}
                    className="toast toast-anchored"
                    style={{ left: t.position.left, top: t.position.top }}
                >
                    {t.message}
                </div>
            ))}

            <div className="toast-stack">
                {toasts.filter(t => !t.position).map(t => (
                    <div key={t.id} className="toast">{t.message}</div>
                ))}
            </div>
        </ToastContext.Provider>
    );
};